module.exports = __webpack_public_path__ + "static/watt-logo-7adc38f95e5ee73c597be0b526c8123f.png";